'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MdLocalGroceryStore = function MdLocalGroceryStore(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm28.4 30q1.3 0 2.3 1t0.9 2.4-0.9 2.3-2.3 0.9-2.4-0.9-1-2.3 1-2.4 2.4-1z m-26.8-26.6h5.5l1.6 3.2h24.7q0.7 0 1.1 0.5t0.5 1.3q0 0.4-0.2 0.7l-6 10.8q-0.9 1.7-2.9 1.7h-12.4l-1.5 2.8 0 0.2q0 0.4 0.3 0.4h19.3v3.4h-20q-1.3 0-2.3-1.1t-0.9-2.3q0-0.8 0.3-1.6l2.3-4.1-6-12.7h-3.4v-3.2z m10 26.6q1.4 0 2.4 1t1 2.4-1 2.3-2.4 0.9-2.3-0.9-0.9-2.3 0.9-2.4 2.3-1z' })
        )
    );
};

exports.default = MdLocalGroceryStore;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/md/local-grocery-store.js
// module id = 1633
// module chunks = 168707334958949